import React, { Component } from "react";
import { Container, Form, Input, FormGroup, Button } from "reactstrap";

import DefaultLayout from "../../components/layouts/defaultlayout/defaultlayout";
import { Validators, FormValidation } from "../../utils/formvalidation";
import FormError from "../../components/formerror/formerror";
import webService from "../../utils/webservice";
import history from "../../utils/history";
import config from "../../utils/config";
import eventsHub from "../../utils/eventshub";

class PageLogin extends Component {
  state = {
    passwordType: "password",
    form: null,
  };

  constructor(props) {
    super(props);

    let form = {
      // email: { value: config.loginUser, validations: [Validators.required, Validators.email] },
      // password: { value: config.loginPass, validations: [Validators.required, Validators.minLength(6)] },
      captcha: { value: "" },
      cuit: { value: config.cuit, validations: [Validators.required, Validators.cuit] },
      transaccion: { value: config.transaccion, validations: [Validators.required] },
    };
    this.formValidation = new FormValidation(form);
    console.log(this.formValidation);
    this.state.form = this.formValidation.getClone();
  }

  showPassword(show) {
    this.setState({ passwordType: show ? "text" : "password" });
  }

  onFormHandleChange(name, value) {
    this.formValidation.setValue(name, value);
    this.setState({ form: this.formValidation.getClone() });
  }

  onFormHandleBlur(name) {
    this.formValidation.setTouched(name);
    this.setState({ form: this.formValidation.getClone() });
  }

  onFormHandleSubmit(event) {
    event.preventDefault();
    this.formValidation.checkForm(true);
    if (!this.formValidation.isValid()) {
      this.setState({ form: this.formValidation.getClone() });
      return;
    }

    let formValue = this.formValidation.getValue();
    /*
    webService.login(formValue.email, formValue.password, formValue.cuit, formValue.transaccion)
      .then(response => {
    */
    webService
      .getIvaExentoData(formValue.cuit, formValue.transaccion)
      .then(ivadata => {
        localStorage.setItem("ivaExentoData", JSON.stringify(ivadata));
        localStorage.setItem("cuit", formValue.cuit);
        localStorage.setItem("transaccion", formValue.transaccion);
        eventsHub.setIvaExentoData(ivadata);

        history.push("/home");
      })
      .catch(error => {
        // console.log(error.response.data);
        if (error.response && error.response.data.message === "El Cuit y Transaccion ya se encuentra informado.") {
          localStorage.setItem("ivaExentoData", JSON.stringify(error.response.data));
          localStorage.setItem("cuit", formValue.cuit);
          localStorage.setItem("transaccion", formValue.transaccion);
          history.push("/home");
        } else {
          localStorage.clear();
          eventsHub.setLoggedIn(false);
          if (error.response && error.response.data.message) {
            alert(error.response.data.message);
          } else {
            alert("Error al comunicarse con el servidor");
          }
        }
      });
    /*
      })
      .catch(error => {
        if (error.response && error.response.data) {
          alert(error.response.data.message);
        } else {
          alert("Error al comunicarse con el servidor");
        }
      });
    */
  }

  render() {
    return (
      <DefaultLayout showSidebar={false}>
        <Container>
          <div className="datos-box bg-white w-50 mx-auto my-5">
            <h2 className="mb-4">Ingreso</h2>
            <Form noValidate onSubmit={this.onFormHandleSubmit.bind(this)}>
              {/*  <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={this.state.form.email.value}
                  invalid={this.state.form.email.invalid}
                  onChange={event => this.onFormHandleChange("email", event.target.value)}
                  onBlur={() => this.onFormHandleBlur("email")}
                />
                <FormError errors={this.state.form.email.errors} />
              </FormGroup>
              <FormGroup>
                <Label>Contrase&ntilde;a</Label>
                <InputGroup>
                  <Input
                    type={this.state.passwordType}
                    value={this.state.form.password.value}
                    invalid={this.state.form.password.invalid}
                    onChange={event => this.onFormHandleChange("password", event.target.value)}
                    onBlur={() => this.onFormHandleBlur("password")}
                  />
                  <InputGroupAddon addonType="append">
                    <Button
                      type="button"
                      color="white"
                      onMouseDown={this.showPassword.bind(this, true)}
                      onMouseUp={this.showPassword.bind(this, false)}
                      onMouseLeave={this.showPassword.bind(this, false)}
                    >
                      <i className="fa fa-eye" />
                    </Button>
                  </InputGroupAddon>
                  <FormError errors={this.state.form.password.errors} />
                </InputGroup>
              </FormGroup> */}
              <FormGroup>
                <label>CUIT</label>
                <Input
                  type="text"
                  value={this.state.form.cuit.value}
                  invalid={this.state.form.cuit.invalid}
                  onChange={event => this.onFormHandleChange("cuit", event.target.value)}
                  onBlur={() => this.onFormHandleBlur("cuit")}
                />
                {console.log(this.state.form.cuit.errors)}
                <FormError errors={this.state.form.cuit.errors} />
              </FormGroup>
              <FormGroup>
                <label>Transacci&oacute;n</label>
                <Input
                  type="text"
                  value={this.state.form.transaccion.value}
                  invalid={this.state.form.transaccion.invalid}
                  onChange={event => this.onFormHandleChange("transaccion", event.target.value)}
                  onBlur={() => this.onFormHandleBlur("transaccion")}
                />
                <FormError errors={this.state.form.transaccion.errors} />
              </FormGroup>

              <div className="text-center">
                <Button type="submit" color="success" className="my-4">
                  INICI&Aacute; SESI&Oacute;N
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </DefaultLayout>
    );
  }
}

export default PageLogin;
